import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../_components/FormComponents/Button';


const InfoCard = ({className}) => (
    <div className={`auth-page__card auth-page__card--info ${className || ''}`}>
        <h1>A new way to share old memories.</h1>
        <p className="lead">Safely, securely and FREE!</p>
        <p className="lead">Welcome to TightKnit, the place where family stories come alive.</p>
        <p>Everything you do on the TightKnit™ platform is private and secure. This is very important to us. Your
            content is your content, and nobody else’s. TightKnit simply provides a place for you to manage your
            content, and to allow your family stories to flourish.</p>
    </div>
);

InfoCard.propTypes = {
    className: PropTypes.string
};


export default InfoCard;



// WEBPACK FOOTER //
// ./src/Pages/AuthPages/InfoCard.js